import { useSyncExternalStore } from 'react';
import { gatewayHealth, type GatewayHealthSnapshot } from '@/lib/feed/gatewayHealthMeter';
import { gatewayActive } from './feedGateway';

let _cached: GatewayHealthSnapshot | null = null;
let _cachedAt = -1;
function read(): GatewayHealthSnapshot | null {
  if (!gatewayActive()) return null;
  const s = gatewayHealth.snapshot();
  // Same beat → same object, so useSyncExternalStore sees a stable value.
  if (_cached && _cachedAt === s.at) return _cached;
  _cached = s;
  _cachedAt = s.at;
  return s;
}

/** The tab's gateway health (null on the fleet transport). Re-renders on each
 *  pong / alive beat (≤ every 5 s), never per frame. */
export function useGatewayHealth(): GatewayHealthSnapshot | null {
  return useSyncExternalStore((fn) => gatewayHealth.subscribe(fn), read, () => null);
}
